<template>
  <div class="modal-mask" @click.self="close">
    <div class="modal">
      <h4>은행코드 업로드</h4>

      <div class="body">
        <button class="ghost" @click="downloadTemplate">업로드 양식 찾기</button>
        <label class="filebtn">
          파일 선택
          <input type="file" accept=".xlsx,.xls" @change="onFile" hidden />
        </label>
        <span v-if="fileName" class="fname">{{ fileName }} · {{ rows.length }}행</span>
      </div>

      <p class="hint">엑셀 컬럼명: 은행코드, 은행명 (여러 탭 지원 — 탭 이름은 메모1에 저장)</p>
      <p v-if="message" :class="error ? 'error' : 'ok'">{{ message }}</p>

      <div class="btns">
        <button class="primary" :disabled="busy || rows.length===0" @click="doUpload">업로드</button>
        <button class="ghost" @click="close">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import api from '../api';

export default {
  name: 'BankCodeUploadDialog',
  data() { return { rows: [], fileName: '', busy: false, message: '', error: false }; },
  methods: {
    downloadTemplate() {
      const ws = XLSX.utils.aoa_to_sheet([['은행코드', '은행명'], ['001', '한국은행']]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '은행목록');
      XLSX.writeFile(wb, '은행코드_업로드_양식.xlsx');
    },
    onFile(e) {
      this.message = ''; this.error = false; this.rows = [];
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.fileName = file.name;
      const reader = new FileReader();
      reader.onload = evt => {
        try {
          const wb = XLSX.read(evt.target.result, { type: 'array' });
          const out = [];
          wb.SheetNames.forEach(tab => {
            const arr = XLSX.utils.sheet_to_json(wb.Sheets[tab], { defval: '' });
            arr.forEach(row => {
              const bankCode = row['은행코드'] != null ? String(row['은행코드']).trim() : '';
              const bankName = row['은행명'] != null ? String(row['은행명']).trim() : '';
              if (bankCode || bankName) out.push({ bankCode, bankName, tab });
            });
          });
          this.rows = out;
          if (out.length === 0) { this.error = true; this.message = '읽을 수 있는 행이 없습니다. 컬럼명(은행코드/은행명)을 확인하세요.'; }
        } catch (err) { this.error = true; this.message = '엑셀 파일을 읽을 수 없습니다.'; }
      };
      reader.readAsArrayBuffer(file);
    },
    async doUpload() {
      if (this.rows.length === 0) return;
      if (!window.confirm('등록하시겠습니까?')) return;
      this.busy = true; this.message = ''; this.error = false;
      try {
        await api.bankCodeUpload(this.rows);
        this.$emit('uploaded');
      } catch (e) { this.error = true; this.message = e.message; }
      finally { this.busy = false; }
    },
    close() { this.$emit('close'); }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 75; }
.modal { background: #fff; padding: 22px; border-radius: 8px; width: 460px; max-width: 94vw; }
.modal h4 { margin: 0 0 14px; }
.body { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.filebtn { padding: 7px 14px; background: #2f6fed; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px; }
.fname { font-size: 12.5px; color: #33415c; }
.ghost { padding: 7px 14px; background: #eef1f7; color: #33415c; border: 1px solid #d0d5dd; border-radius: 6px; cursor: pointer; }
.hint { font-size: 12px; color: #667085; margin: 12px 0 4px; }
.error { color: #d93636; font-size: 13px; }
.ok { color: #1a7f37; font-size: 13px; }
.btns { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
.btns .primary { padding: 8px 16px; background: #2f6fed; color: #fff; border: none; border-radius: 6px; cursor: pointer; }
.btns .primary:disabled { background: #9db8ef; }
</style>
